import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
    CheckSVTStatus, CustomerData, RsaInterface, ServiceHistoryDetailInterface,
    StartStopSVT, TransactionInterface, TripDetailInterface, VehicleDashboardInterface,
    VinEngineData
} from 'src/app/core/models/customer-details';
import { environment } from '../../../environments/environment';

import { HttpService } from './http-service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SvtService {


    constructor(
        private http: HttpClient,
        private httpService: HttpService,
        private router: Router
    ) { }


    getAccessToken(id): Observable<any> {
        const url = environment.apiUrl + environment.supportPortal.getAccessToken;
        
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                id,
                Authorization: environment.appRegistry.authId
            })
        };
        return this.http.get(url, httpOptions).pipe(
            map((res: Response) => {
                return res || {};
            }),
            catchError(this.errorMgmt)
        );
    }

    getSvtLocation(data: { svtAccessToken: any; id: any; productOwnId: any; }): Observable<any>  {
        const url = environment.apiUrl + environment.supportPortal.getSvtLocation;
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                svtAccessToken: data.svtAccessToken,
                id: data.id,
                productOwnId: data.productOwnId
            })
        };
        return this.http.get(url, httpOptions).pipe(
            map((res: Response) => {
                return res || {};
            }),
            catchError(this.errorMgmt)
        );
    }

    // Error handling
    errorMgmt(error: HttpErrorResponse) {
        let errorMessage: any;
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = error;
        }
        return throwError(errorMessage);
    }
}



